// removed by extract-text-webpack-plugin
module.exports = {"button":"button-module__button___38F6g","about":"button-module__about___2XZD-","report":"button-module__report___3U7s4","govResponse":"button-module__govResponse___HtZ08"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button/button.module.scss
// module id = 120
// module chunks = 0